<template>
    <div id="companygrid">
        <app-gridview 
            v-bind:parentData = "{
                tabHeaders: this.dataHeader,
                tabItems: this.dataItems,
                pageTitle: this.pageTitle,
                search: this.search,
            }"
            v-on:EditItem="editItemHandler($event)"
            v-on:DeleteItem="deleteItemHandler($event)"
            v-on:NewPressed="newRecordHandler"
        ></app-gridview>
    </div>
</template>
<script>
//import moment from 'moment';

import GridView from '../../../components/common/GridView';

export default {
    components: {
        'app-gridview': GridView
    },

    data() {
        return {
            pageTitle: this.$t('letterlist.letterlist'),
            dataHeader: [
                { text: this.$t('columns.actions'), value: 'action', sortable: false, width:'50px' },
                { text: this.$t('letterlist.templatetypeid'), value: 'templatetype', width: '200px' },
                { text: this.$t('letterlist.templatename'), value: 'templatename', width: '200px' },
                { text: this.$t('letterlist.templateclassid'), value: 'templateclassdesc', width: '200px' },
                { text: this.$t('columns.disable'), value: 'disable', width: '100px' },
            ],
            dataItems: [],
            loading: false,
            errMsg: '',
            search: this.$route.params.search,
        }
    },

    methods: {
        getLetterListHandler() {
            const vm = this;

            this.loading = !this.loading;

            this.$store.dispatch('get', {url: '/letter/all'})
                .then(function (res) {
                    vm.dataItems = res.data.rec;

                    vm.loading = !vm.loading;
                })
                .catch(function (err) {
                    vm.errMsg = err;
                });

        },

        editItemHandler(item) {
            this.$router.push({name: 'letteredit', params: {  id: item.id, search: item.search } });
        },

        newRecordHandler() {
            this.$router.push({name: 'letternew'});
        }
    },

    mounted() {
        this.getLetterListHandler();
    }
}
</script>